import { Injectable, ElementRef } from '@angular/core';
import { DragulaService } from 'ng2-dragula';
import autoScroll from 'dom-autoscroller';

/**
 * This service is used when we use drag and drop and there are too many items for dragging and there is a scroll.
 * So we need to 'hold' item, and drag automatically as we dragging item in that container.
 * Always provide this service in component level
 */
@Injectable()
export class AutoScrollService {
    private draggingInProgress: boolean;

    constructor() { }

    public init(dragulaService: DragulaService, elementRef: ElementRef) {
        dragulaService.dragend().subscribe(() => {
            this.draggingInProgress = false;
        });

        dragulaService.drag().subscribe(() => {
            this.draggingInProgress = true;
        });

        // tslint:disable-next-line:no-unused-expression
        new autoScroll([
            elementRef.nativeElement
        ], {
                margin: 20,
                maxSpeed: 5,
                scrollWhenOutside: true,
                autoScroll: () => {
                    return this.draggingInProgress;
                }
            });
    }
}
